module.exports = __webpack_public_path__ + "img/be-delivered.73e5df41.svg";